import { PluginType, type IExportPlugin } from '@/version-types';
import { ImageEffectPlugin } from './controller';
import imageEffectPluginState from './states/image-effect-state';
import { ImageEffectPanelHost } from './views';

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 10,
    name: 'stage-image-effect',
    render() {
        return <ImageEffectPanelHost />;
    },
    createInstance({ identity }) {
        return [{ key: 'ImageEffectPlugin', value: new ImageEffectPlugin(identity) }];
    },
    createState() {
        return [imageEffectPluginState];
    },
};

export default exportPlugin;
